import Reveal from '@/components/base/Reveal';
import { influencerStories } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function InfluencerSection() {
  return (
    <section id="influencer" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="03 / Creators"
          title="网红黑料"
          desc="直播间、选品单、合作纠纷——镜头背后的那一面，我们按时间替你排好。"
        />

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {influencerStories.map((story, i) => (
            <Reveal key={story.id} delay={i * 60}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300">
                <div className="h-52 w-full overflow-hidden">
                  <img
                    src={story.img}
                    alt={`网红黑料：${story.title}`}
                    title={`${story.title} · 91吃瓜网红黑料`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between gap-3">
                    <span className="rounded border border-secondary-200 bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {story.tag}
                    </span>
                    <span className="text-[11px] text-foreground-400">{story.reads} 阅读</span>
                  </div>
                  <p className="mt-3 text-xs text-foreground-500">{story.handle}</p>
                  <h3 className="mt-1 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-secondary-800 md:text-lg">
                    {story.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{story.summary}</p>
                  <span className="mt-4 flex items-center gap-1 text-xs font-medium text-secondary-700">
                    看完整经过
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}